import { render, staticRenderFns } from "./files-data-view.vue?vue&type=template&id=d828a98e&scoped=true"
import script from "./files-data-view.vue?vue&type=script&lang=js"
export * from "./files-data-view.vue?vue&type=script&lang=js"
import style0 from "./files-data-view.vue?vue&type=style&index=0&id=d828a98e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d828a98e",
  null
  
)

export default component.exports